<template>
    <div class="page">
        <p>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br />
            {{ userStore.user.address }}
            <br />
            {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
        </p>
        <p>
            {{ date }}
        </p>
        <p>
            <b>{{ creditBureau.address_name }}</b>
            <br />
            <b>{{ address.street }}</b>
            <br />
            <b>{{ address.city }}, {{ address.state_abbreviation }} {{ address.zipcode }}</b>
        </p>
        <p class="letter-content">
            To Whom It May Concern:
        </p>
        <p class="letter-content">
            I recently received a copy of my credit report and I noticed your furnishing an account on my consumer report that should not be on there. I demand the below account/s be deleted from my consumer report.
        </p>
        <p class="letter-content">
            <i>List of accounts to be deleted</i>
        </p>
        <p v-for="creditor in reportStore.getSelectedAccounts(1, creditBureau.id, null, reportStore.getFilter())">
            <strong>
                {{ creditor.furnisher_name }} with account number 
                <template v-if="creditor.reference_number">
                    {{ creditor.reference_number }}
                </template>
                <template v-else>
                    {{ creditor.account_number }}
                </template>
            </strong>
            <template v-if="creditor.reason">
                <br />
                {{ creditor.reason }}
            </template>
        </p>
        <p class="letter-content">
            The reporting of these account(s) is/are violations of 15 USC §1681a, The Fair Credit Reporting Act [15 USC §1681(a)(2)(B)]:
        </p>
        <p class="letter-content">
            <b>(2)Exclusions.</b>—Except as provided in paragraph (3), the term “consumer report” does not includ
        </p>
        <p class="letter-content">
            <b>(B)</b> any authorization or approval of a specific extension of credit directly or indirectly by the issuer of a credit card or similar device;
        </p>
        <p class="letter-content">
            So let me explain. Under the Truth in Lending Act 15 USC §1602(l), “credit card” is defined as the following:
        </p>
        <p class="letter-content">
            The term “credit card” means any card, plate, coupon book or other credit device existing for the purpose of obtaining money, property, labor, or services on credit.
        </p>
        <p class="letter-content">
            This makes my social security card, driver’s license/ID, and license plate credit cards that are/were used for the extension of credit.
        </p>
        <p class="letter-content">
            I demand this account be deleted from my consumer report.
        </p>
        <p class="letter-content">
            Best regards,
        </p>
        <p class="letter-content">
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
        </p>
    </div>
    <div class="page-content">
        <h1 style="padding: 0rem; 3rem; text-align: center;">Enclosures</h1>
        <p style="padding-top:3rem; text-align: center;">
            <img v-if='userStore.user.ssn_image_url' v-bind:src='userStore.user.ssn_image_url' width='300' height='200' />
            <img v-if='userStore.user.identity_image_url' v-bind:src='userStore.user.identity_image_url' width='300' height='200' />
        </p>
        <p v-if='userStore.user.address_verify_image_url'>
            <img v-bind:src='userStore.user.address_verify_image_url' width='300' height='200' />
        </p>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useReportStore } from '../../stores/ReportStore.js'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    import lodash from 'lodash'
    export default {
        props: {
            creditBureau: {
                type: [Array, Object]
            }
        },
        setup(props) {
            const address = lodash.find(props.creditBureau.addresses, { 'id': props.creditBureau.selected_address });
            return {
                date: ref(moment().format('LL')),
                reportStore: useReportStore(),
                userStore: useUserStore(),
                address,
            };
        }
    };
</script>